/**
 *
 * Asynchronously loads the component for AnnouncementStrip
 *
 */

import loadable from 'utils/loadable';

export default loadable(() =>
  import(/* webpackChunkName: "AnnouncementStrip" */ './index'),
);
